import type { ReactNode } from 'react';

import { cn } from '@/shared/lib/utils';
import { Icon, type PhxIconName } from '@/shared/ui/icon';

export interface InfoBarProps {
  /** Ikona vlevo (volitelná). */
  icon?: PhxIconName;
  /** Popisek vlevo. */
  label: ReactNode;
  /** Hlavní hodnota / obsah; když chybí (`undefined`/`null`), zobrazí se pomlčka. */
  value?: ReactNode;
  /** Vykreslit hodnotu mono fontem (kódy, souřadnice apod.). */
  mono?: boolean;
  /** Tlumená poznámka vpravo. */
  note?: ReactNode;
  /** Akce vpravo (např. tlačítko); má přednost před `note`. */
  action?: ReactNode;
  className?: string;
}

/**
 * Univerzální informační proužek — ikona + popisek + hodnota + volitelná pravá poznámka nebo akce.
 * Tlumené podbarvení (`surface-2`). Použití např. pro souřadnice, kódy, stavové či souhrnné údaje.
 */
export function InfoBar({ icon, label, value, mono, note, action, className }: InfoBarProps) {
  return (
    <div
      className={cn(
        'phx-infobar bg-phx-surface-2 border-phx-border rounded-phx px-phx-3 gap-phx-3 flex min-h-[36px] items-center border',
        className
      )}
    >
      {icon ? <Icon name={icon} size={13} className="text-phx-text-muted shrink-0" /> : null}
      <span className="text-phx-sm text-phx-text-2 shrink-0">{label}</span>
      <span className={cn('text-phx-sm text-phx-text min-w-0 truncate', mono && 'font-mono')}>
        {value ?? <span className="text-phx-text-faint">—</span>}
      </span>
      {action ? (
        <span className="ml-auto shrink-0">{action}</span>
      ) : note ? (
        <span className="text-phx-xs text-phx-text-muted ml-auto shrink-0">{note}</span>
      ) : null}
    </div>
  );
}
